<nb-action class="close-dialog" icon="close-outline" (click)="closeAction()"></nb-action>
@if (extern) {
  <nb-card>
    <nb-card-header>Suppression d'un compte externe</nb-card-header>
    <nb-card-body>
      <div class="row">
        <div class="col-sm-12">
          <div class="form">
            <p>Confirmez-vous la suppression du compte : <strong>{{ extern.name }}</strong></p>
          </div>
        </div>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton fullWidth status="danger" shape="round" (click)="deleteAction()" class="mb-2"
      [disabled]="(loading)">Confirmer la suppression</button>
    </nb-card-footer>
  </nb-card>
}